"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
function truncateRichText(richText, maxLength) {
    if (maxLength === void 0) { maxLength = 200; }
    // String indexes start from 0 so we need to lower
    // max length number by 1 for every element.
    var adjustedMaxLength = maxLength;
    if (!richText) {
        return [];
    }
    var currentLength = 0;
    var elements = [];
    richText.forEach(function (element) {
        if (element.type === 'numbered-list' || element.type === 'bulleted-list') {
            element.children.forEach(function (listItem) {
                elements.push(listItem);
            });
        }
        else {
            elements.push(element);
        }
    });
    var content = elements.reduce(function (partialText, element) {
        adjustedMaxLength -= 1;
        // Truncate text
        if (currentLength < adjustedMaxLength) {
            var elementChildren = element.children.reduce(function (nodes, node) {
                if (currentLength < adjustedMaxLength) {
                    var text = node.text
                        ? node.text.slice(0, adjustedMaxLength - currentLength)
                        : '';
                    currentLength += text.length;
                    return __spread(nodes, [{ text: text }]);
                }
                return nodes;
            }, []);
            return __spread(partialText, [__assign(__assign({}, element), { children: elementChildren })]);
        }
        return partialText;
    }, []);
    return content;
}
exports.default = truncateRichText;
//# sourceMappingURL=truncateRichText.js.map